import { ResultSet } from "@cubejs-client/core";

import { AppThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

export class ClientFeatureName {
    public readonly DefaultFeatureName: string;
    public readonly ClientFeatureName: string;

    constructor(
        defaultFeatureName: string,
        clientFeatureName: string
    ) {
        this.DefaultFeatureName = defaultFeatureName;
        this.ClientFeatureName = clientFeatureName;
    }
}

export const loadClientFeatureNames = (): AppThunk<Promise<ClientFeatureName[]>> => async (dispatch) => {
    try {
        const clientFeatureNamesQuery = {
            dimensions: [
                "ClientFeatureName.DefaultFeatureName",
                "ClientFeatureName.ClientFeatureName"
            ],
            filters: [{
                member: "ClientFeatureName.ClientFeatureName",
                operator: "notEquals",
                values: [null]
            }],
            limit: 50000
        };
        const resultSetClientFeatureNames = await dispatch(cubeLoad(clientFeatureNamesQuery)) as unknown as ResultSet;
        return resultSetClientFeatureNames.rawData().map(row => new ClientFeatureName(
            row["ClientFeatureName.DefaultFeatureName"],
            row["ClientFeatureName.ClientFeatureName"]
        ));
    } catch (error) {
        dispatch(logError("Error loading Client Feature Names.", error));
        throw error;
    }
};
